
export const AssetWarrantyDetailValisation = (formData) => {
    const errors = {};

    if (!formData.dt_WarrantyStartDate || !formData.dt_WarrantyStartDate.trim()) {
        errors.dt_WarrantyStartDate = 'This field is required';
    }

    if (!formData.dt_WarrantyEndDate || !formData.dt_WarrantyEndDate.trim()) {
        errors.dt_WarrantyEndDate = 'This field is required';
    }
    if (!formData.vc_WarrantyDescription || !formData.vc_WarrantyDescription.trim()) {
        errors.vc_WarrantyDescription = 'This field is required';
    }

    if (formData.dt_WarrantyStartDate && formData.dt_WarrantyEndDate) {
        const startDate = new Date(formData.dt_WarrantyStartDate);
        const endDate = new Date(formData.dt_WarrantyEndDate);
    
        if (endDate <= startDate) {
            errors.dt_WarrantyEndDate = 'End Date must be greater than Start Date';
        }
    }

    

    return errors;
};
